<template>
  <div class="overlay-wrapper">
    <div v-if="articles">
      <h2 v-html="articles.DATA[id].NAME" />
      <div v-html="decodeHtml(articles.DATA[id].DETAIL_TEXT)" />
    </div>
    <c-loading-overlay v-if="fetching" />
  </div>
</template>

<script>
import breadcrumbs from '../mixins/breadcrumbs'
import Notification from '../notification'
import apiService from '../apiService'
import CLoadingOverlay from '../components/ui/CLoadingOverlay'
import { decodeHtml } from '../helper'

export default {
  name: 'ArticleDetail',
  components: { CLoadingOverlay },
  mixins: [breadcrumbs],
  props: {
    id: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      articles: null,
      fetching: true
    }
  },
  mounted () {
    this.fetch()
  },
  methods: {
    fetch () {
      this.fetching = true

      apiService.getPublicationsDetail('articles', this.id)
        .then(response => {
          this.articles = response.data
          this.$title = decodeHtml(response.data.DATA[this.id].NAME)
          this.breadcrumbTitleUpdate('ArticleDetail', decodeHtml(response.data.DATA[this.id].NAME))
        })
        .catch(() => {
          Notification.notifyError({
            title: 'Ошибка',
            content: 'Не удалось загрузить статью.'
          })
        })
        .finally(() => {
          this.fetching = false
        })
    },
    decodeHtml
  }
}
</script>
